import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { API_ENDPOINTS } from '../../../../core/services/api.service';
import { CommonService } from '../../../../shared/services/common.service';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(public commonSvc: CommonService) { }

  getAssetByCustomerId(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSETS.LISTING + data)
  }

  getAssetByLocation(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSETS.BY_LOCATION, data)
  }

  getAssetSensorMappingByCustomerId(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSET_SENSOR_MAPPING.LISTING + data)
  }

  getAllEnvironments(customer_id: string): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.MASTER.GET_ENV_BY_CUSTOMER + '/' + customer_id)
  }

  addAsset(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSETS.ADD, data)
  }

  addAssetExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSETS.ADD_EXCEL, data)
  }

  updateAsset(data: any): Observable<any> {
    return this.commonSvc.httpSvc.put<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSETS.UPDATE, data)
  }

  deleteAsset(asset_id: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSETS.DELETE, { asset_id })
  }

  getSensorsByCustomerId(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.LISTING + data)
  }

  getWhitelistData(): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.UNASSIGNED)
  }

  getUnmappedExternalSensors(): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.WHITELIST.EXTERNAL_SENSORS)
  }

  getGatewaysByLocation(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.BY_CUSTOMER, data)
  }

  addSensor(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.ADD, data)
  }

  updateSensor(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.UPDATE, data)
  }

  addSensorExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.EXCEL, data)
  }

  deleteSensor(sensorId: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.DELETE, sensorId)
  }

  getHooterbyCustomerId(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.HOOTER.LISTING + data)
  }

  getModelNumber(): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.HOOTER.GET_MODEL_NO)
  }

  getDeviceEUI(): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.WHITELIST.HOOTERS)
  }

  addHooter(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.HOOTER.ADD, data)
  }

  addHooterExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.HOOTER.EXCEL, data)
  }

  updateHooter(data: any): Observable<any> {
    return this.commonSvc.httpSvc.put<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.HOOTER.UPDATE, data)
  }

  deleteHooter(idt_hooter: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.HOOTER.DELETE, idt_hooter)
  }

  getGatewaysbyCustomerId(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.LISTING + data)
  }

  getSerialNo(): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.GET_SERIAL_NO)
  }

  addGateway(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.ADD, data)
  }

  addGatewayExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.EXCEL, data)
  }

  updateGateway(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.UPDATE, data)
  }

  deleteGateway(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GATEWAY.DELETE, data)
  }

  addAssetSensorMappingExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSET_SENSOR_MAPPING.ADD_EXCEL, data)
  }

  deleteAssetSensorMapping(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ASSET_SENSOR_MAPPING.DELETE, data)
  }

  requestExternalSensorData(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.logsUrl + API_ENDPOINTS.DEVICE_MANAGEMENT.SENSORS.REQUEST_EXTERNAL_SENSOR, data)
  }

  addTransportInventory(data: any, customerId: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-customer-id': customerId
    });
    return this.commonSvc.httpSvc.post<any[]>(
      environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.TRANSPORT.ADD_INVENTORY,
      data,
      headers
    );
  }

  getTransportInventory(customerId: string, filters?: { location_id?: string, status?: string }): Observable<any> {
    const headers = new HttpHeaders({
      'x-customer-id': customerId
    });
    return this.commonSvc.httpSvc.get<any[]>(
      environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.TRANSPORT.GET_INVENTORY,
      headers
    );
  }

  updateTransportInventory(inventoryId: string, payload: any): Observable<any> {
    return this.commonSvc.httpSvc.patch<any>(
      environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.TRANSPORT.UPDATE_INVENTORY ,inventoryId,payload,
    );
  }

  addTransportInventoryExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any[]>(
      environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.TRANSPORT.EXCEL,
      data
    );
  }

  deleteTransportInventory(sensorId: string): Observable<any> {
    return this.commonSvc.httpSvc.delete<any[]>(
      environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.TRANSPORT.DELETE_INVENTORY, 
      sensorId
    );
  }

  addBulkDevice(data: any, customerId: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-customer-id': customerId
    });
    return this.commonSvc.httpSvc.postFile<any[]>(
      environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.SENSOR.ADD_BULK_DEVICE,
      data,
      headers
    );
  }
}
